import { api } from './api';
import { setUser } from './user';
import { mixpanelAlias, trackAlias, trackIdentity } from './analytics';
import { captureError } from './monitoring';
import {
  convertToSlug,
  formatPhoneNumberWithGBCountryCode,
  formatPhoneNumberWithNoCountryCode,
} from './formatting';
import { getPlaceDetails, getExactAddress } from './googlePlaces';
import { removeFalsy } from './object';
import { generateUuid } from './uuid';

export const createSupplierUser = async user => {
  try {
    const { data } = await api.post('/users/signup', {
      ...user,
      phone: formatPhoneNumberWithNoCountryCode(user.phone),
      type: 'supplier',
    });

    setUser(data.accessToken);
    mixpanelAlias(data.userId);
    trackAlias(data.userId);
    trackIdentity(data.userId, {
      phone: formatPhoneNumberWithGBCountryCode(user.phone),
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    });

    return data.userId;
  } catch (error) {
    captureError(error);
    throw error;
  }
};

export const createSupplier = async (
  { locationAutocomplete, manualLocation, ...supplier },
  mutation
) => {
  try {
    const slug = convertToSlug(supplier.name);
    const uuid = generateUuid();

    if (!manualLocation) {
      const details = await getPlaceDetails(locationAutocomplete?.value);
      supplier = removeFalsy({ ...supplier, ...getExactAddress(details) });
    }

    const newSupplier = await mutation({
      variables: {
        ...supplier,
        uuid,
        slug,
      },
    });

    return newSupplier?.data?.createSupplier?.uuid;
  } catch (createSupplierError) {
    captureError(createSupplierError);
  }
};

export const linkUserSupplier = async (userId, supplierUuid, mutation) => {
  const uuid = generateUuid();

  try {
    await mutation({
      variables: {
        uuid,
        supplierUuid,
        userId,
      },
    });

    return true;
  } catch (error) {
    captureError(error);
  }
};
